import { render, staticRenderFns } from "./editListApp.vue?vue&type=template&id=84b81ad0&scoped=true&"
import script from "./editListApp.vue?vue&type=script&lang=js&"
export * from "./editListApp.vue?vue&type=script&lang=js&"
import style0 from "./editListApp.vue?vue&type=style&index=0&id=84b81ad0&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b81ad0",
  null
  
)

export default component.exports